var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M18.806 8.135a9 9 0 0 1 .146 2.8 8.98 8.98 0 0 1-2.918 5.743l-2.948-2.38a5.3 5.3 0 0 0 1.875-2.454h-4.906v-3.71z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M10 15.29c1.15 0 2.215-.366 3.083-.99l2.95 2.379A8.97 8.97 0 0 1 10 19a9 9 0 0 1-8.018-4.907l3.022-2.347A5.29 5.29 0 0 0 10 15.29"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  d: "m2.02 5.833 3.02 2.322A5.3 5.3 0 0 0 4.71 10c0 .635.111 1.245.317 1.81l-3.039 2.295A8.96 8.96 0 0 1 1 10c0-1.504.369-2.921 1.02-4.167"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M10 1a8.97 8.97 0 0 1 6.379 2.651l-2.613 2.632a5.293 5.293 0 0 0-8.725 1.87l-3.02-2.32A9 9 0 0 1 10 1"
}))));
export default SvgIconGoogle;